import fetch from '../utils/fetch';

// 判断用户是否已经领取新人注册礼包
export function creditAccountHasDrawNewcustomerCredit() {
  return fetch.get('/shopmember/api/credit/hasDrawNewcustomerCredit');
}

// 领取新人注册礼包
export function creditAccountDrawNewcustomerCredit(data) {
  return fetch.post('/shopmember/api/credit/drawNewcustomerCredit', data);
}

/**
 *
 *根据类型获取微页面配置信息
 * @export
 * @param {*} type
 * @returns
 */
export function featureConfigGetByType(type) {
  return fetch.get(`/soyoung/api/featureConfig/getByType?type=${type}`);
}

export function featureConfigListByTypesForApp(types) {
  return fetch.post(`/newretail/api/featureConfig/listByTypesForApp`, types);
}
export function soyoungCreditGetCreditAndSignInfo(orderId) {
  return fetch.get(`/shopmember/api/credit/getCreditAndSignInfo?orderId=${orderId}`);
}
